import { formatDate } from 'utils/date';

export function saveAsFile(content, filename, contentType) {
  const blob = new Blob([content], { type: contentType });
  const url = URL.createObjectURL(blob);

  console.log(url);

  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', filename);
  link.click();
}

export function saveAsPDF(content, filename) {
  const link = document.createElement('a');
  link.href =
    'data:application/pdf;charset=utf-8,' + encodeURIComponent(content);

  const fileName = `${filename}-${formatDate(new Date().toISOString())}`;
  link.setAttribute('download', fileName);
  link.click();
}
